import { StateMileageTaxRatesState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const stateMileageTaxRateState: StateMileageTaxRatesState = {
  iftaTaxRates: [],
  totalCount: 0,
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  sortBy: 'state',
  sortField: 'state',
  // year: String(new Date().getFullYear()) as StateMileageTaxRatesState['year'],
  // quarter: new Date().getMonth() % 3 + 1 as StateMileageTaxRatesState['quarter'],
  year: '2024',
  quarter: 1,
  state: '',
  csvUploadModal: false,
};
